import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import DecimalMonetario from "../../decimal";

export const MoneyFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, handleBlur, errors,
}) => (
  <>
    <DecimalMonetario
      getFieldValue={getFieldValue}
      handleInputChange={handleInputChange}
      campo={{ nome: campo.nome, tipo: "monetario", required: campo.required, modo }}
      apenasLeitura={campo.apenasLeitura}
      onBlur={() => handleBlur(campo)}
      hasError={!!errors[campo.nome]}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
